import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Bar } from 'react-chartjs-2';
import { useSelector } from 'react-redux';
import { TState } from '../../redux/store';
import { Box, Flex, Text } from '@chakra-ui/react';
import { colors } from './StatsSettings';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  ChartDataLabels,
);

export default function RBarChart({
  data,
  isCompare,
}: {
  data: any;
  isCompare?: boolean;
}) {
  const theme = useSelector((state: TState) => state.theme);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context: any) {
            return (
              context.dataset.label.replace(/previous|current/gi, '') +
              ': ' +
              context.raw
            );
          },
        },
      },
      datalabels: {
        backgroundColor: (ctx: any) => {
          const value = ctx.datasetIndex; // valeur du point

          if (!isCompare) return 'transparent';
          if (value % 2) return colors.curr;
          return colors.prev;
        },
        color: !isCompare ? theme.main : '#fff', // couleur texte
        borderRadius: 4,
        padding: 4,
        anchor: 'end' as const,
        align: 'top' as const,
        font: {
          weight: 'bold' as const,
          size: Number(theme.fontSize.xxSmall.replace('px', '')),
          backgroundColor: 'red' as const,
        },
        formatter: (value: string) => value,
      },
      legend: {
        position: 'top' as const,
        labels: {
          display: false,
          generateLabels() {
            return [];
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          display: false,
          font: {
            size: Number(theme.fontSize.xxSmall.replace('px', '')),
          },
        },
      },
      y: {
        suggestedMax: (ctx: any) => {
          const max = Math.max(
            ...ctx.chart.data.datasets.flatMap((d: any) => d.data),
          );
          return max * 1.1; // +10% de marge
        },
        display: false,
        // stacked: true,
      },
    },
  };

  return (
    <>
      <Box flexGrow={1} w={'100%'}>
        <Bar data={data} options={options} />
      </Box>
      <Flex mt={-2}>
        {data.labels.map((label: string[]) => (
          <Box
            w={`${100 / data.labels.length}%`}
            textAlign='center'
            pt={1}
            fontSize={theme.fontSize.xSmall}
          >
            {label.map((l) => (
              <Text>{l}</Text>
            ))}
          </Box>
        ))}
      </Flex>
    </>
  );
}
